import {combineReducers} from "redux";

import blog from "../features/admin/blogs/blog/Slice";

import common from "../features/admin/common/Slice";

const blogs = combineReducers({
    blog,
    common
});

export default blogs;